import Splide from '@splidejs/splide'
class Sliders  {
    constructor() {

        // Services Slider //
        this.animationEndEventName = this.getAnimationEndEventName()
        if(document.querySelector('.services-slider')){
            this.serviceSlider = new Splide( '.services-slider', {
                arrows: false,
                pagination: false,
                perPage: 3,
                gap: '1.5rem',
                padding: {
                    right: '10rem',
                    left : '5rem',
                },
                speed: 1000,
                breakpoints: {
                    1280: {
                        perPage: 2,
                        padding: {
                            right: '5rem',
                            left : '2rem',
                        },
                    },
                    1024: {
                        perPage: 1,
                        padding: {
                            right: '10rem',
                            left : '5rem',
                        },
                    }
                  }
            } ).mount()
        }

        // Projects Slider //
        if(document.querySelector('.products-slider')){
            this.buttonTimer = document.querySelector('.timer')
            this.iconTimer = document.querySelector('.timer-icon')
            this.nextProductExcept = document.querySelector('.next-product-excerpt')
            this.nextProductTitle = document.querySelector('.next-product-title')
            this.nextProductThumb = document.querySelector('.next-product-thumb')
            this.curProductTitle = document.querySelector('.product-title')
            this.curProductExcerpt = document.querySelector('.product-description')
            this.curProductLink = document.querySelector('.product-link')
            this.curProductIndex = document.querySelector('.product-index')
            this.procuctNavItems = document.querySelectorAll('.product-nav-item')
            this.procuctNavLinks = document.querySelectorAll('.products-slider-link')
            document.querySelector('.next-product-button').addEventListener('click',el=>{
                el.preventDefault()
                this.productsSlider.go('>')
            })
            this.productsSlider = new Splide( '.products-slider', {
                type: 'loop',
                arrows: false,
                pagination: false,
                perPage: 1,
                speed: 1000,
            } ).mount()
            
            this.productSliderTimer()
            this.nextProductSlide()
            this.currentSlideInfo()
            this.productsSlider.on('move', () => {
                this.currentSlideInfo()
                this.nextProductSlide()
                this.buttonTimer.classList.add("animate")
                clearTimeout(this.timeClear)
            })

            this.procuctNavLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault()
                    const target = e.currentTarget
                    const index = Number(target.getAttribute('data-order'))
                    this.productsSlider.go(index)
                    this.buttonTimer.classList.remove("animate")
                    this.iconTimer.classList.toggle("fa-play")
                    this.iconTimer.classList.toggle("fa-pause")
                    clearTimeout(this.timeClear)
                })
            })

            this.buttonTimer.addEventListener('click', (e) => {
                e.preventDefault()
                this.togglePlayPause()
            })
        }

        // Projects Nav Slider //
        if(document.querySelector('.products-nav-slider')){
            this.productsNavSlider = new Splide( '.products-nav-slider', {
                arrows: false,
                pagination: false,
                autoWidth: true,
                perPage: 7,
                gap: '1rem',
                speed: 1000,
                breakpoints: {
                    1280: {
                        perPage: 1,
                        padding: {
                            right: '2rem',
                            left : '2rem',
                        },
                        
                    }
                }
            } ).mount()
        }

        // Floorplans Slider //
        if(document.querySelector('.floorplans-slider')){
            this.floorplansSlider = new Splide( '.floorplans-slider', {
                arrows: false,
                pagination: false,
                perPage: 3,
                gap: '1rem',
                padding: {
                    right: '10rem',
                    left : '5rem',
                },
                speed: 1000,
                breakpoints: {
                    640: {
                        perPage: 1,
                        padding: {
                            right: '5rem',
                            left : '2rem',
                        },
                    }
                }
            } ).mount()
        }

        // Testimonials Slider //
        if(document.querySelector('.testimonial-slider')){
            this.testimonialSlider = new Splide( '.testimonial-slider', {
                type: 'loop',
                autoplay: true,
                arrows: false,
                pagination: false,
                perPage: 1,
                speed: 1000,
            } ).mount()
        }

        // Gallery Slider //
        if(document.querySelector('.gallery-slider')){
            this.galleryPagination = document.querySelector('.gallery-pagination')
            this.sliderPosition = document.querySelector('.slider-position')
            this.gallerySlider = new Splide( '.gallery-slider', {
                type: 'loop',
                arrows: false,
                pagination: false,
                perPage: 1,
                autoplay: true,
                speed: 1000
            } ).mount()
            this.createPagination(this.gallerySlider)
        }
    }

    // EVENTS //
    getSliderArrows(){
        if(this.arrowLeft){
            this.arrowLeft.addEventListener('click',()=>{
                this.testimonialsSlider.go('<')
            })
        }
        if(this.arrowRight){
            this.arrowRight.addEventListener('click',()=>{
                this.testimonialsSlider.go('>')
            })
        }
    }
    createPagination(el){
        let sliderLength = el.length
        if(!document.querySelector('.gallery-pagination li')){
            for(let i = 0; i < sliderLength; i++){
                let paginationItem = document.createElement('li')
                let pgChild = document.createElement('p') 
                paginationItem.classList.add('pagination-item')
                if(i == 0){
                    paginationItem.classList.add('is-active')
                }
                paginationItem.addEventListener('click',()=>{
                    this.gallerySlider.go(i)
                })
                paginationItem.appendChild(pgChild)
                this.galleryPagination.appendChild(paginationItem)
            }
        }
        this.sliderPosition.innerHTML = `01 / 0${sliderLength}`
        this.updatePagination()
    }
    updatePagination(){
        this.gallerySlider.on('move', (newIndex) => {
            this.sliderPosition.innerHTML = `0${newIndex+1} / 0${this.gallerySlider.length}`
            let paginationItems = document.querySelectorAll('.gallery-pagination li')
            paginationItems.forEach((item, index) => {
                if(index == newIndex){
                    item.classList.add('is-active')
                }else{
                    item.classList.remove('is-active')
                }
            })
        })
    }
    productSliderTimer(){
        this.buttonTimer.addEventListener(this.animationEndEventName, this.listenerAnimationFunction = ()=>{
            this.buttonTimer.classList.remove("animate")
            void this.buttonTimer.offsetWidth
            this.setTimer()
        })
    }
    setTimer(){
        this.timeClear = setTimeout(()=>{this.callback()}, 50);
    }
    callback(){
        this.productsSlider.go('>')
    }
    togglePlayPause(){
       this.buttonTimer.classList.toggle("animate")
       this.iconTimer.classList.toggle("fa-play")
       this.iconTimer.classList.toggle("fa-pause")
       clearTimeout(this.timeClear)
    }
    nextProductSlide(){
        let nextSlide
        if(this.productsSlider.length == this.productsSlider.index + 1){
            nextSlide = this.productsSlider.Components.Elements.slides[0]
        }else{
            nextSlide = this.productsSlider.Components.Elements.slides[ this.productsSlider.index + 1 ];
        }
        
        let dataTitle = nextSlide.getAttribute('data-title');
        let dataThumb = nextSlide.getAttribute('data-thumb');
        let dataExcerpt = nextSlide.getAttribute('data-excerpt');
        this.nextProductExcept.innerHTML = dataExcerpt
        this.nextProductTitle.innerHTML = dataTitle
        let next_thumb_img = this.nextProductThumb.querySelector('img')
        let next_thumb_src = this.nextProductThumb.querySelector('source')
        next_thumb_img.src = dataThumb
        next_thumb_src.srcset = dataThumb
    }
    currentSlideInfo(){
        this.procuctNavItems.forEach((item, index) => {
            item.classList.remove('active')
            if(index == this.productsSlider.index){
                item.classList.add('active')
            }
        })
        let curSlide = this.productsSlider.Components.Elements.slides[ this.productsSlider.index ];
        let dataTitle = curSlide.getAttribute('data-title');
        let dataIndex = curSlide.getAttribute('data-index');
        let dataExcerpt = curSlide.getAttribute('data-excerpt');
        let dataLink = curSlide.getAttribute('data-link');
        this.curProductTitle.innerHTML = dataTitle
        this.curProductIndex.innerHTML = dataIndex
        this.curProductExcerpt.innerHTML = dataExcerpt
        this.curProductLink.setAttribute('href', dataLink);
    }
    // For Animation Keyframes
    getAnimationEndEventName() {
        let transitions = {
            "animation"      : "animationend",
            "OAnimation"     : "oAnimationEnd",
            "MozAnimation"   : "animationend",
            "WebkitAnimation": "webkitAnimationEnd"
        }
        let bodyStyle = document.body.style
        for(let transition in transitions) {
            if(bodyStyle[transition] != undefined) {
                return transitions[transition]
            } 
        }
    }
}

export default Sliders